import React, { useState } from 'react';
import api from '../../services/api';
import './CreateOrderModal.css';

const emptyFormData = {
  customer_name: '',
  customer_phone: '',
  customer_email: '',
  item_description: '',
  intake_notes: '',
};

const LogInquiryModal = ({ isOpen, onClose, onSuccess }) => {
  const [formData, setFormData] = useState({ ...emptyFormData });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [errors, setErrors] = useState({});

  const formatPhoneNumber = (value) => {
    const digits = value.replace(/\D/g, '');
    if (digits.length <= 3) return digits;
    if (digits.length <= 6) return `${digits.slice(0, 3)}-${digits.slice(3)}`;
    return `${digits.slice(0, 3)}-${digits.slice(3, 6)}-${digits.slice(6, 10)}`;
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    const processedValue = name === 'customer_phone' ? formatPhoneNumber(value) : value;

    setFormData((prev) => ({ ...prev, [name]: processedValue }));

    if (errors[name]) {
      setErrors((prev) => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.customer_name.trim()) {
      newErrors.customer_name = 'Customer name is required';
    }

    if (!formData.item_description.trim()) {
      newErrors.item_description = 'Describe what the customer is asking for';
    }

    return newErrors;
  };

  const handleClose = () => {
    setFormData({ ...emptyFormData });
    setErrors({});
    setError(null);
    setSuccess(false);
    onClose();
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const newErrors = validateForm();
    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setLoading(true);
    setError(null);

    try {
      const response = await api.post('/special-orders/inquiries', formData);
      setSuccess(true);

      setTimeout(() => {
        onSuccess?.(response.data.inquiry);
        handleClose();
      }, 1000);
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to log inquiry');
    } finally {
      setLoading(false);
    }
  };

  if (!isOpen) return null;

  return (
    <div className="create-order-modal-overlay active" onClick={handleClose}>
      <div className="create-order-modal-content" onClick={(e) => e.stopPropagation()}>
        <div className="create-order-modal-header">
          <h2>Log Special Order Inquiry</h2>
          <button className="modal-close-btn" onClick={handleClose}>&times;</button>
        </div>

        {success && <div className="success-message">✓ Inquiry logged successfully!</div>}
        {error && <div className="error-message">{error}</div>}

        <div className="create-order-modal-body">
          <form onSubmit={handleSubmit} className="create-order-form">
            <div className="form-section">
              <h4>Customer Information</h4>

              <div className="form-group">
                <label htmlFor="customer_name">
                  Customer Name <span className="required">*</span>
                </label>
                <input
                  type="text"
                  id="customer_name"
                  name="customer_name"
                  value={formData.customer_name}
                  onChange={handleChange}
                  maxLength="255"
                  placeholder="Enter customer name"
                  className={errors.customer_name ? 'input-error' : ''}
                />
                {errors.customer_name && <span className="error-text">{errors.customer_name}</span>}
              </div>

              <div className="form-row">
                <div className="form-group">
                  <label htmlFor="customer_phone">Phone</label>
                  <input
                    type="tel"
                    id="customer_phone"
                    name="customer_phone"
                    value={formData.customer_phone}
                    onChange={handleChange}
                    placeholder="123-456-7890"
                  />
                </div>

                <div className="form-group">
                  <label htmlFor="customer_email">Email</label>
                  <input
                    type="email"
                    id="customer_email"
                    name="customer_email"
                    value={formData.customer_email}
                    onChange={handleChange}
                    placeholder="Optional"
                  />
                </div>
              </div>
            </div>

            <div className="form-section">
              <h4>What are they looking for?</h4>

              <div className="form-group">
                <label htmlFor="item_description">
                  Item Requested <span className="required">*</span>
                </label>
                <textarea
                  id="item_description"
                  name="item_description"
                  value={formData.item_description}
                  onChange={handleChange}
                  rows="3"
                  placeholder="e.g. Marucci CAT9 -8 USSSA bat, 30/22"
                  className={errors.item_description ? 'input-error' : ''}
                ></textarea>
                {errors.item_description && <span className="error-text">{errors.item_description}</span>}
              </div>

              <div className="form-group">
                <label htmlFor="intake_notes">Notes</label>
                <textarea
                  id="intake_notes"
                  name="intake_notes"
                  value={formData.intake_notes}
                  onChange={handleChange}
                  rows="2"
                  placeholder="Anything else worth passing along to Justin/Dale"
                ></textarea>
              </div>
            </div>
          </form>
        </div>

        <div className="create-order-modal-footer">
          <button type="button" onClick={handleClose} className="btn-secondary" disabled={loading}>
            Cancel
          </button>
          <button type="button" onClick={handleSubmit} className="btn-primary" disabled={loading}>
            {loading ? 'Logging...' : 'Log Inquiry'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default LogInquiryModal;
